import P from "prop-types";
import * as S from "../styles";

import { HorizontalBarChartCard } from "../../ChartCards/HorizontalBarChartCard";
import { SimplePieChartCard } from "../../ChartCards/SimplePieChartCard";

import { dadosGraficos } from "../../dados";

export function Capitulo2({ currentIndex }) {
  const chartStyle = {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  if (currentIndex !== 2) {
    return <></>;
  } else {
    return (
      <S.Container>
        <S.Container2>
          <S.Grid>
            <SimplePieChartCard
              grid
              title="Reside com pessoas do grupo de risco"
              style={chartStyle}
              dados={dadosGraficos.grafico13}
            />

            <SimplePieChartCard
              grid
              title="Pessoas evitaram contato devido à covid-19"
              style={chartStyle}
              dados={dadosGraficos.grafico16}
            />
          </S.Grid>

          <HorizontalBarChartCard
            title="Afastou-se do trabalho para se recuperar"
            dados={dadosGraficos.grafico21}
            style={chartStyle}
          />

          <S.Grid>
            <SimplePieChartCard
              grid
              title="Acredita ter se contaminado no trabalho"
              style={chartStyle}
              dados={dadosGraficos.grafico19}
            />

            <SimplePieChartCard
              grid
              title="Teve covid-19"
              style={chartStyle}
              dados={dadosGraficos.grafico18}
            />
          </S.Grid>
        </S.Container2>
      </S.Container>
    );
  }
}

Capitulo2.propTypes = {
  currentIndex: P.number.isRequired,
};
